// extracted by mini-css-extract-plugin
export default {"containerBg":"UpdateContractByCustomer_containerBg__1pdx8"};